import { ElementRef, EventEmitter, Input, ViewChild, Output, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

import { FormField, Link, Disclaimer } from './form-field.model';
import { DynamicOverlaysDirective } from './dynamic-overlays.directive';

export class FieldComponent implements AfterViewInit {

  @Input() field: FormField;
  @Input() defaultValue: any;
  @Input() draftData: any;
  @Input() templateData: any;
  @Input() workflowId: number;
  @Output() focusChanged = new EventEmitter<boolean>();
  @Output() focusTabbed = new EventEmitter<FieldComponent>();
  @Output() highlightChanged = new EventEmitter<{highlighted: boolean, color?: string}>();
  @Output() resized = new EventEmitter<FieldComponent>();
  @Output() returnKey = new EventEmitter<FieldComponent>();
  @Output() undoableAction = new EventEmitter<UndoAction>();
  @Output() updateLinked = new EventEmitter<{link: Link, value?: any, categories?: any[], enabled?: boolean}>();
  @Output() valueChanged = new EventEmitter<{field: string, value: any}>();
  @Output() viewLoaded = new EventEmitter<FieldComponent>();
  @ViewChild("input") input: ElementRef;

  id: string;
  copyable: boolean = true;
  control: FormControl;
  disclaimer: Disclaimer;
  dropdownWidth: number;
  dynamicOverlays: DynamicOverlaysDirective;
  focused: boolean;
  highlightColor: string;
  highlighted: boolean;
  initialized: boolean = false;
  label: string;
  locked: boolean;
  lockValues: boolean;
  touched: boolean;
  valid: boolean;
  value: any;

  protected _dirty: boolean = false;
  protected _disabled: boolean = false;

  get blank(): boolean { return this.value == null }
  get dirty() {return this._dirty}
  get disabled() {return this._disabled}
  get errors(): ValidationErrors {
    return this.control != null ? this.control.errors : null
  }
  get errorDescriptions(): string[] {
    let descriptions: string[] = [];
    for (let key in this.errors) {
      let value = this.errors[key];
      let description = this.descriptionForError(key, value);
      descriptions.push(description != null ? description : 'is invalid')
    }
    return descriptions;
  }
  get invalid(): boolean { return !this.valid && (!this.blank || this.touched) }

  constructor(public cd: ChangeDetectorRef) { }

  ngAfterViewInit() {
    this.viewLoaded.emit(this);
  }

  compare(other): number { return 0 }

  blur() {
    if (this.input != null) {
      this.input.nativeElement.blur();
    }
  }

  descriptionForError(key, value): string {
    switch (key) {
    case 'email':
      return 'must be a valid email address';
    case 'max':
      return 'must be less than ' + value.max;
    case 'maxLength':
      return 'must be shorter than ' + value.maxLength;
    case 'min':
      return 'must be less than ' + value.min;
    case 'minLength':
      return 'must be shorter than ' + value.minLength;
    case 'pattern':
      return 'is not in the correct format';
    case 'required':
      return 'is required';
    case 'requiredTrue':
      return 'must be true';
    }
  }

  disable() {
    if (this.control != null) {
      this.control.disable({emitEvent: false});
    } else if (this.input != null) {
      this.input.nativeElement.disabled = true;
    }
    this._disabled = true;
  }

  enable() {
    if (this.control != null) {
      this.control.enable({emitEvent: false});
    } else if (this.input != null) {
      this.input.nativeElement.disabled = false;
    }
    this._disabled = false;
  }

  focus() {
    if (this.input != null) {
      this.input.nativeElement.focus();
    }
  }

  positionOverlays() { }
  reset() { }

  resetDirty(templateValue) {
    if (this._dirty) {
      this.defaultValue = this.valueFromTemplate(templateValue);
      this._dirty = !this.valuesEqual(this.defaultValue, this.value);
      this.cd.markForCheck();
    }
  }

  resetPreviousValue() { }
  setCategories(category: any) { }
  setPatternValue(field: string, value: any) { }
  setPreviousValue(value: any) { }
  setValue(value: any, emit?: boolean) { }
  undo(action: UndoAction) { }
  updateLinkedFields() { }
  updateLinkedRows() { }

  setLockValues(state) {
    this.lockValues = state;
    if (this.lockValues && !this.blank) {
      this.locked = true;
      this.disable();
    } else {
      this.locked = false;
      this.enable();
    }
  }

  valuesEqual(a,b): boolean {
    return a === b;
  }

  valueFromTemplate(templateValue) {
    return templateValue;
  }

}

export interface UndoAction {
  description: string,
  field: FieldComponent,
  value: any
}


// WEBPACK FOOTER //
// ./src/app/forms/field.component.ts